import type { QueryClient } from "@tanstack/react-query";

const AVATAR_QUERY_ROOTS = new Set([
  "candidateDetails",
  "candidates",
  "team-candidates",
  "team-candidates-all",
  "floats",
  "team-floats",
  "float",
  "publicFloat",
  "float-candidates",
  "team-float-candidates",
  "submissions",
  "team-submissions",
  "submission",
  "publicSubmission",
  "submission-candidates",
  "team-submission-candidates",
]);

/** Refresh every view that can include a candidate profile avatar. */
export function invalidateCandidateAvatarQueries(queryClient: QueryClient) {
  return queryClient.invalidateQueries({
    predicate: ({ queryKey }) => AVATAR_QUERY_ROOTS.has(String(queryKey[0])),
  });
}
